module.exports = __webpack_public_path__ + "img/二次催付.170d1c53.svg";